<template>
  <div>
    <b-card>
      <b-card-body>
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
          <b-form ref="observer" @submit.prevent="handleSubmit(search)">
            <b-row>
              <b-col lg="4" md="4">
                <ValidationProvider v-slot="{ errors }" :rules="'required'" name="countrySelected">
                  <b-form-group>
                    <PFormSelect
                      v-model="countrySelectedId"
                      :options="optionsCountry"
                      optionValue="id"
                      optionText="descripcion"
                      :label="$t('label.pais')"
                      :placeholder="$t('option.select')"
                      @input="resetTable"
                    />
                    <b-form-invalid-feedback id="select-countrySelected-feedback">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col lg="4" md="4">
                <ValidationProvider v-slot="{ errors }" :rules="'required'" name="tableSelected">
                  <b-form-group>
                    <PFormSelect
                      v-model="tableSelected"
                      :options="optionsTable"
                      optionValue="key"
                      optionText="label"
                      :label="$t('label.tabla')"
                      :placeholder="$t('option.select')"
                      @input="search"
                    />
                    <b-form-invalid-feedback id="select-tableSelected-feedback">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
            </b-row>
          </b-form>
        </ValidationObserver>
      </b-card-body>
    </b-card>
    <columnas-table
      v-if="tableSelected && countrySelected"
      :config="config"
      :country="countrySelected"
      :table="tableSelected"
      v-on:update="search"
    ></columnas-table>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";
import Multiselect from "vue-multiselect";
import { Action, Getter } from "vuex-class";
import { IPaisParams, IPaisResponse } from "@/services";
import { IConfColumnaPais, IConfColumnaParams, IPais } from "@/entities";
import ColumnasTable from "@/components/administracion/columnas/ColumnasTable.vue";

@Component({
  components: { ColumnasTable, ValidationObserver, Multiselect },
})
export default class AdminColumnasComponent extends Vue {
  @Action("fetchPais")
  fetchPais!: (params?: IPaisParams) => Promise<IPaisResponse | undefined>;

  @Action("fetchTablasPais")
  fetchTablasPais!: () => Promise<string[] | undefined>;

  @Action("fetchConfColumnasPais")
  fecthConfColumnasPais!: (params: IConfColumnaParams) => Promise<IConfColumnaPais[] | undefined>;

  @Getter("getPaises") optionsCountry!: IPais[];

  public countrySelected: IPais | null = null;
  public countrySelectedId: number | null = null;
  public tableSelected: string | null = null;

  public optionsTable: { label: string; key: string }[] | undefined = [];

  public config: IConfColumnaPais[] | null = null;

  constructor() {
    super();
  }

  async mounted(): Promise<void> {
    await this.searchCountryTables();
  }

  async searchCountryTables(): Promise<void> {
    this.optionsTable = [
      { label: "Saldos", key: "saldos" },
      { label: "Detalle Saldos", key: "detalle_saldos" },
      { label: "Entradas", key: "entradas" },
      { label: "Salidas", key: "salidas" },
      { label: "Documentacion", key: "documentosNonHistorical" },
      { label: "Transferencias Propias - Ofertas", key: "propiasOfertas" },
      { label: "Transferencias Propias - Demandas", key: "propiasDemandas" },
      { label: "Transferencias Publicas - Ofertas", key: "publicasOfertas" },
      { label: "Transferencias Publicas - Demandas", key: "publicasDemandas" },
    ];
  }

  resetTable(): void {
    this.countrySelected =
      this.optionsCountry.find((pais) => pais.id === this.countrySelectedId) || null;
    this.tableSelected = null;
  }

  async search(): Promise<void> {
    if (this.countrySelected) {
      const rest = await this.fecthConfColumnasPais({
        codPais: this.countrySelected.codPaisCorto,
        codTabla: this.tableSelected,
      });
      if (rest) {
        this.config = rest;
      } else {
        this.config = null;
      }
    }
  }

  async update(): Promise<void> {
    await this.search();
  }
}
</script>
